module.exports = __webpack_public_path__ + "img/Poorter_hotel-210.f00296fa.jpg";